import { ActionButtons as AntdActionButtons } from "@empglabs/backoffice-ui-kit"

const ActionButtons = props => {
  return <AntdActionButtons {...props} />
}

export default ActionButtons
